import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Note from "./Note";
import CreateArea from "./CreateArea";

function App() {

    var [allNotes , setAllNotes] = useState([]);

    function addNote(note) {
        setAllNotes((prevNotes) => {
           return [...prevNotes , note];
        })
    }

     function deleteNote(id) {
        setAllNotes((prevNotes) => {
            return prevNotes.filter((_note , index) =>{
                return index !== id;
        });
     });
    }

  return (
    <div>
      <Header />
      <CreateArea 
        onAdd = {addNote}
      />
      {allNotes.map((note , index) => {
          return <Note 
            title= {note.title}
            content= {note.content}
            key = {index}
            id = {index}
            onChecked = {deleteNote}
          />
      })}
      
      <Footer />
    </div>
  );
}

export default App;
